import { registerSectionType } from "../../utils/sectionRegistry";
import { resolveImageUrl } from "../../../../utils/imageUtils";

registerSectionType({
  type: "franja",
  label: "Franja",
  layout: "simple",
  previewBlocks: ["Imagen", "Titulo"],
  getDefaults: () => ({ type: "franja", title: "", image: null, to: "" }),
  editorFields: [
    { key: "href", label: "URL de redireccion", placeholder: "https://..." },
  ],
  render: (section, index) => {
    const imageSrc = resolveImageUrl(section?.image?.src);
    const className = imageSrc ? "dynamic-franja" : "dynamic-franja dynamic-franja--fallback";
    const style = imageSrc ? { backgroundImage: `url(${imageSrc})` } : undefined;
    const content = (
      <section
        key={`franja-${index}`}
        className={className}
        style={style}
      >
        {section?.title ? <span className="dynamic-franja-title">{section.title}</span> : null}
      </section>
    );
    if (section?.to) {
      return (
        <a
          key={`franja-link-${index}`}
          href={section.to}
          target="_blank"
          rel="noreferrer noopener"
        >
          {content}
        </a>
      );
    }
    return content;
  },
});
